(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["framework--instagram"] && !window.DesignMode) return;
  try {
    

;(function ($) {
  $.fn.instagramLite = function (options) {
    if (!this.length) {
      return this;
    }

    self.el = $(this);
    self.loadContent();
  },

  loadContent = function () {
    var accessToken = el.data("access-token");
    el.each(function () {
      var url = 'https://graph.instagram.com/me/media?fields=id,media_url,media_type,like_count,caption,timestamp,thumbnail_url,permalink&access_token=' + accessToken;
      $.ajax({
        type: 'GET',
        url: url,
        dataType: 'jsonp',
        success: function (data) {
          if (data.data.length) {
            for (var i = 0; i < 5; i += 1) {
              var thisMedia = data.data[i];
              var item;

              // if media type is image
              if (thisMedia.media_url) {
                item = '<img class="il-photo__img" src="' + thisMedia.media_url + '" alt="Instagram Image" />';
                item = '<a href="' + thisMedia.permalink + '" target="_blank">' + item + '</a>';
              }
              var item = "<div class=\"one-fifth column\">" + item + "</div>";

              // append image 
              el.append(item);
            }
          }
          $.ajax({
            type: "GET",
            url: "https://graph.instagram.com/refresh_access_token?grant_type=ig_refresh_token&access_token=" + accessToken
          });
        },
        error: function (e) {
          console.error(e);
        }
      });
    });
  }
})(jQuery);

$(function () {
  var $target = $("#instafeed");
  $target.instagramLite();
});


  } catch(e) { console.error(e); }
})();

})();
